import { render, staticRenderFns } from "./relations-result.vue?vue&type=template&id=4f49bf36&scoped=true"
import script from "./relations-result.vue?vue&type=script&lang=js"
export * from "./relations-result.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f49bf36",
  null
  
)

export default component.exports